import { CURRENCY } from "@utils/constant";
import { DISCOUNT_TYPE } from "@utils/enum";

export const formatDiscountValue = (value, type) => {
  const symbol = type === DISCOUNT_TYPE.PERCENTAGE ? "%" : CURRENCY;
  return `${value} ${symbol}`;
};
